import { Auth } from '@nackle/bridge';
import { idURL } from './utils/endpoints';

const auth = new Auth( {
    authority: idURL,
    debug: false
} );

export default auth;

export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );
    
    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

export const permissions = {
    EDIT_TOPIC: 'tributary.edit-topic',
    LIST_TOPICS: 'tributary.list-topics',
    READ_TOPIC: 'tributary.read-topic'
};
